jQuery(function($){ // use jQuery code inside this to avoid "$ is not defined" error
	$('.sjr-load-more').click(function(){
	
		var button = $(this),
			data = {
			'action': 'loadmore',
			'query': button.data('posts'), // that's how we get params from wp_localize_script() function
			'page' : button.data('currentpage'),
			'offset' : button.data('offset')
		};
		
		var page = button.data('currentpage');
		
		$.ajax({ // you can also use $.post here
			url : sjr_loadmore_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) { 
					//console.log(data);
					button.text( 'Load more').parents('.top-stories').find('.top-stories-container').append(data); // insert new posts
					page = page +1;
					button.data('currentpage', page);
	
					if ( button.data('currentpage') == button.data('maxpage') ) 
						button.remove(); // if last page, remove the button
	
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	});
});